// Contact form → API Gateway → contact Lambda (JSON POST). Shows inline status,
// disables the button while sending, and re-enables on error. The honeypot
// field (`company`) is submitted as-is; the server silently drops it if filled.
import { recaptchaToken, resetRecaptcha, postForm } from "./recaptcha.js"

export default function initContact() {
  const form = document.querySelector("[data-contact-form]")
  if (!form) return

  const endpoint = form.getAttribute("data-endpoint")
  const button = form.querySelector("[data-contact-submit]")
  const status = form.querySelector("[data-contact-status]")
  const originalLabel = button ? button.textContent.trim() : "Verstuur bericht"

  const setStatus = (msg, ok) => {
    if (!status) return
    status.textContent = msg
    status.classList.remove("hidden", "text-emerald-600", "text-red-600")
    status.classList.add(ok ? "text-emerald-600" : "text-red-600")
  }

  form.addEventListener("submit", async (e) => {
    e.preventDefault()
    if (!endpoint || !button) return

    const token = recaptchaToken(form)
    if (!token) {
      setStatus("Vink eerst aan dat je geen robot bent.", false)
      return
    }

    button.disabled = true
    button.textContent = "Versturen…"

    const res = await postForm(endpoint, {
      naam: form.elements.name.value,
      email: form.elements.email.value,
      bericht: form.elements.message.value,
      company: form.elements.company ? form.elements.company.value : "",
      token,
    })
    resetRecaptcha(form)

    if (res.ok) {
      form.reset()
      button.textContent = "Verzonden ✓"
      button.classList.add("bg-emerald-500")
      setStatus("Dank je. Je bericht is verstuurd, je hoort snel van ons.", true)
    } else {
      button.disabled = false
      button.textContent = originalLabel
      setStatus(res.message || "Versturen is niet gelukt. Probeer het later nog eens.", false)
    }
  })
}
